module.exports = new __parcel__URL__("bossfight_hp_icon.784ad8c5.png").toString();